import React, { useEffect, useState, useRef } from "react";
import "./MostVisit.css";

// Image imports
import t1 from "../../Assets/ujjain.png";
import t2 from "../../Assets/omkareshwer.png";
import t3 from "../../Assets/khatushyam.png";
import t4 from "../../Assets/sawariya seth.png";
import t5 from "../../Assets/baglamukhi.png";

const temples = [
  { 
    name: "Mahakaleshwar", img: t1, price: "3,250", route: "Indore → Ujjain", tag: "Most Popular",
    rates: { sedan: "3,250", suv: "4,500" } 
  },
  { 
    name: "Omkareshwar", img: t2, price: "3,500", route: "Indore → Omkareshwar", tag: "Holy River",
    rates: { sedan: "3,500", suv: "4,800"} 
  },
  { 
    name: "Khatu Shyam", img: t3, price: "20,000", route: "Indore → Khatu Shyam", tag: "Grand Tour",
    rates: { sedan: "20,000", suv: "25,000" } 
  },
  { 
    name: "Sawariya Seth", img: t4, price: "8,500", route: "Indore → Sawariya Seth", tag: "Divine",
    rates: { sedan: "8,500", suv: "10,500" } 
  },
  { 
    name: "Baglamukhi Maa", img: t5, price: "4,700", route: "Indore → Baglamukhi", tag: "Peaceful",
    rates: { sedan: "4,700", suv: "6,200" } 
  },
];

const MostVisit = () => {
  const [index, setIndex] = useState(0);
  const [selectedTemple, setSelectedTemple] = useState(null);
  const touchStart = useRef(null);
  const isMoving = useRef(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!selectedTemple) {
        setIndex((prev) => (prev + 1) % temples.length);
      }
    }, 4000);
    return () => clearInterval(interval);
  }, [selectedTemple]);

  const handleTouchStart = (e) => {
    touchStart.current = e.touches[0].clientX;
    isMoving.current = false;
  };

  const handleTouchMove = (e) => {
    if (!touchStart.current) return;
    const touchEnd = e.touches[0].clientX;
    const diff = touchStart.current - touchEnd;

    if (Math.abs(diff) > 10) isMoving.current = true;

    if (Math.abs(diff) > 50) {
      if (diff > 0) setIndex((prev) => (prev + 1) % temples.length);
      else setIndex((prev) => (prev - 1 + temples.length) % temples.length);
      touchStart.current = null;
    }
  };

  const openRates = (e, temple) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedTemple(temple);
  };

  return (
    <section className="temple-section-dark">
      <div className="section-header">
        <span className="subtitle">Divine Pilgrimage</span>
        <h2>Most Visited Temples</h2>
        <div className="underline"></div>
      </div>

      <div 
        className="slider-container"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
      >
        <div className="slider-content">
          {temples.map((temple, i) => {
            let position = "slide-hidden";
            if (i === index) position = "slide-active";
            else if (i === (index - 1 + temples.length) % temples.length) position = "slide-prev";
            else if (i === (index + 1) % temples.length) position = "slide-next";

            return (
              <div 
                key={i} 
                className={`temple-card ${position}`} 
                onClick={() => { if (!isMoving.current) setIndex(i); }}
              >
                <div className="card-inner">
                  <div className="image-box">
                    <img src={temple.img} alt={temple.name} />
                    <span className="badge">{temple.tag}</span>
                  </div>
                  <div className="text-box">
                    <h3>{temple.name}</h3>
                    <p className="route-text">📍 {temple.route}</p>
                    <div className="footer-row">
                      <div className="price-container">
                        <span className="from-label">From</span>
                        <span className="price-start">₹{temple.price}</span>
                      </div>
                      <button 
                        className="details-btn" 
                        onClick={(e) => openRates(e, temple)}
                        onTouchEnd={(e) => openRates(e, temple)}
                      >
                        Rates
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {selectedTemple && (
        <div className="modal-overlay" onClick={() => setSelectedTemple(null)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={() => setSelectedTemple(null)}>&times;</button>
            <div className="modal-header">
              <h3>{selectedTemple.name}</h3>
              <p>Pricing for {selectedTemple.route}</p>
            </div>
            
            <div className="rate-list">
              <div className="rate-card">
                <span>Sedan (4+1)</span> 
                <strong>₹{selectedTemple.rates.sedan}</strong>
              </div>
              <div className="rate-card">
                <span>SUV (6+1)</span> 
                <strong>₹{selectedTemple.rates.suv}</strong>
              </div>
            </div>

            <div className="modal-actions">
              <a 
                href={`https://wa.me/919755357721?text=I want to book a trip to ${selectedTemple.name}`} 
                className="wa-action"
                target="_blank" 
                rel="noopener noreferrer"
              >
                WhatsApp Booking
              </a>
              <a href="tel:+919755357721" className="call-action">Call Now</a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default MostVisit;